import React from 'react'
import styles from '../../styles/products.module.css';

interface ProductAmrRobotCaseItemProps {
    title: string;
    icon: string;
}


const ProductAmrRobotCaseItem: React.FC<ProductAmrRobotCaseItemProps> = ({ icon, title }) => {
    return (
        <div className={styles.serviceCases}>
            <div className={styles.iconBox}>
                <img src={icon} alt="icon" />
            </div>
            <span>{title}</span>
        </div>

    )
}

export default ProductAmrRobotCaseItem;